// Track active timers for cleanup
const activeTimers = new Set();

export const viewIntersectionObserver = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.click();
				const timerId = setTimeout(() => {
					entry.target.scrollIntoView({
						block: "center",
						inline: "center",
					});
					activeTimers.delete(timerId);
				}, 500);
				activeTimers.add(timerId);

				viewIntersectionObserver.unobserve(entry.target);
			}
		});
	},
	{ threshold: 0.1 }
);

/**
 * Cleanup function to call on component unmount.
 * Clears all pending timers and disconnects the IntersectionObserver.
 */
export function cleanupTaskScroller() {
	activeTimers.forEach(clearTimeout);
	activeTimers.clear();
	viewIntersectionObserver.disconnect();
}

export default function modelTaskScroller(elementName) {
	elementName.scrollIntoView({
		behavior: "smooth",
		block: "start",
		inline: "center",
		top: elementName.getBoundingClientRect().bottom + window.pageYOffset,
	});

	viewIntersectionObserver.observe(elementName);
}
